export const SLIDE_SHOW_MODEL_TYPES = {
  classroom_activity: 'classroomActivity',
  investigation_activity: 'investigationActivity',
  lesson_outline: 'lessonOutline',
  reading_activity: 'readingActivity',
  video_activity: 'videoActivity',
};
